export const PASSWORD_HINT = "En az 8 karakter, en az 1 harf ve 1 rakam";

export const passwordError = (pw) => {
    const p = pw || "";
    if (p.length < 8 || !/[A-Za-zÇĞİÖŞÜçğıöşü]/.test(p) || !/\d/.test(p)) {
        return "Şifre en az 8 karakter olmalı ve en az 1 harf ile 1 rakam içermelidir";
    }
    return null;
};
